import { SIMPLE_MEDICAL_RECORD } from '../actionTypes'

const initialState = {
  data: [],
  total: 0,
  current: null,
  loading: false,
  error: null,
  success: null
}

export default function simpleMedicalRecordReducer (state = initialState, action) {
  switch (action.type) {
    case SIMPLE_MEDICAL_RECORD.LIST_REQUEST:
      return { ...state, loading: true, error: null }
    case SIMPLE_MEDICAL_RECORD.LIST_SUCCESS:
      return { ...state, loading: false, data: action.data, total: action.total, error: null }
    case SIMPLE_MEDICAL_RECORD.LIST_FAILURE:
      return { ...state, loading: false, data: [], total: 0, error: action.error }

    case SIMPLE_MEDICAL_RECORD.GET_ONE_REQUEST:
      return { ...state, loading: true, current: null, error: null }
    case SIMPLE_MEDICAL_RECORD.GET_ONE_SUCCESS:
      return { ...state, loading: false, current: action.data, error: null }
    case SIMPLE_MEDICAL_RECORD.GET_ONE_FAILURE:
      return { ...state, loading: false, current: null, error: action.error }

    case SIMPLE_MEDICAL_RECORD.CREATE_API_REQUEST:
      return { ...state, loading: true, error: null, success: null }
    case SIMPLE_MEDICAL_RECORD.CREATE_API_SUCCESS:
      return { ...state, loading: false, error: null, success: true }
    case SIMPLE_MEDICAL_RECORD.CREATE_API_FAILURE:
      return { ...state, loading: false, error: action.error, success: null }

    case SIMPLE_MEDICAL_RECORD.UPDATE_REQUEST:
      return { ...state, loading: true, error: null, success: null }
    case SIMPLE_MEDICAL_RECORD.UPDATE_SUCCESS: {
      const data = state.data.map((item) => (item.id === action.data.id ? action.data : item))
      return { ...state, loading: false, data, current: action.data, success: true, error: null }
    }
    case SIMPLE_MEDICAL_RECORD.UPDATE_FAILURE:
      return { ...state, loading: false, error: action.error, success: null }

    case SIMPLE_MEDICAL_RECORD.CLEAR_NOTIFY:
      return { ...state, error: null, success: null }

    default:
      return state
  }
}
